import ScormAPI from '@/lib/ScormApi/ScormAPI'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import CMI_InteractionsCorrectResponsesObjectInterface
  from "@/lib/ScormApi/Scorm/interfaces/CMI_InteractionsCorrectResponsesObjectInterface"

export default function CMI_InteractionsCorrectResponsesObject (API: ScormAPI): CMI_InteractionsCorrectResponsesObjectInterface {
  const jsonString = true
  let _pattern = ""

  return {
    get pattern (): any {
      return (!jsonString) ? API.throwSCORMError(404) : _pattern
    },
    set pattern (pattern) {
      _pattern = pattern
    },
    toJSON: new JsonFormatter().apply
  }
}
